import { render, staticRenderFns } from "./policyDetail.vue?vue&type=template&id=79115a21&scoped=true"
import script from "./policyDetail.vue?vue&type=script&lang=js"
export * from "./policyDetail.vue?vue&type=script&lang=js"
import style0 from "./policyDetail.vue?vue&type=style&index=0&id=79115a21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79115a21",
  null
  
)

export default component.exports